import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.createBulkClasses.loading;
export const selectErrorMessage = (state: RootState) =>
  state.createBulkClasses.error;
export const createBulkClassDataResponse = (state: RootState) =>
  state.createBulkClasses.createBulkClassResponse;
